import './src/styles/fonts.css';
import './src/styles/normalise.min.css';
import './src/styles/main.css';

import React from 'react';
import Layout from './src/components/layout';
import { getConsent, loadAnalytics, trackPageView } from './src/consent';

const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};

// Fires on initial load and every SPA route change. Analytics stays inert until
// the visitor has accepted; loadAnalytics is idempotent.
const onRouteUpdate = () => {
  if (getConsent() === 'granted') {
    loadAnalytics();
    trackPageView();
  }
};

export { wrapPageElement, onRouteUpdate };
